import React, { useEffect, useState, useCallback } from 'react';
import { Spinner } from 'react-bootstrap';
import { subscribe } from '../../../services/creator';
import { trackSubscriptionEvent } from '../../../utils/analytics';

type Props = {
  plan: Plan;
};

const CreditCard: React.FC<Props> = ({ plan }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [url, setUrl] = useState('');

  const fetchUrl = useCallback(async () => {
    try {
      setLoading(true);
      const url = await subscribe(plan.creatorId, plan.id);

      // Rastreamento de evento de assinatura iniciada
      trackSubscriptionEvent(
        'subscribe',
        plan.creatorId,
        `${plan.value / 100}`
      );

      setUrl(url);
    } catch {
      setLoading(false);
      setError(true);
    }
  }, [plan.creatorId, plan.id, plan.value]);

  useEffect(() => {
    fetchUrl();

    return () => {
      setLoading(false);
      setError(false);
    };
  }, [fetchUrl, plan]);

  return (
    <div
      className="d-flex bg-white justify-content-center align-items-center flex-column"
      style={{ height: '70vh' }}
    >
      {!loading && error && (
        <div
          style={{
            display: 'flex',
            position: 'absolute',
            zIndex: 2,
            width: '100%',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            backgroundColor: 'white',
            padding: 10,
          }}
        >
          <i className="feather-alert-circle text-warning mb-5 display4-size"></i>
          <p className="text-grey-600 font-xs text-center">
            Ocorreu um problema ao carregar os dados para o pagamento. Por
            favor, tente novamente.
          </p>
          <button
            onClick={fetchUrl}
            className="btn p-2 m-2 rounded-md bg-warning font-xssss fw-700 text-white profile-card-buttons-subscriptions-buttons"
          >
            Tentar Novamente
          </button>
        </div>
      )}
      {loading && (
        <div
          style={{
            display: 'flex',
            position: 'absolute',
            zIndex: 1,
            width: '100%',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
          }}
        >
          <Spinner className="text-warning" />
        </div>
      )}
      <iframe
        src={url}
        title="ls"
        width="100%"
        height="100%"
        max-width="100%"
        onLoad={() => setLoading(false)}
      />
      <div className="bg-white mt-3 w-100">
        <p className="text-grey-600 fw-600 font-xss text-center">
          Fechar essa tela ao finalizar o pagamento
        </p>
      </div>
    </div>
  );
};

export default CreditCard;
